const AdminDashboard = {
  getAdminDashboard: {
    url: "/admin/dashboard",
    method: "GET",
  },
  getAdminDashboardLineGraph: {
    url: "/admin/dashboard/line/graph",
    method: "GET",
  },
  getAdminDashboardPieChart: {
    url: "/admin/dashboard/pie-chart",
    method: "GET",
  },
};

export default AdminDashboard;
